/* tslint:disable */
/* eslint-disable */
/**
 * Joule Conductor Cloud
 * This specification document describes the Joule Technologies Application Programming Interface  (API). The endpoints, message formats and status codes are explained in this document. ## Communication  ### Base URI  The base Uniform Resource Identifier (URI) is: https://user-api.joule-cloud.com/v2 This URI is the prefix for all endpoints described in this document. ### Body format  The endpoints of the API expecting a body must be in JavaScript Object Notation (JSON) format.  Response bodies from the endpoints also adhere to this standard, unless otherwise stated.  Responses will include a Content-Type header indicating the ‘application/json’ type. An invalid  or missing body will result in a 400-status code accompanied by an error code to specify the  nature of the error. ### Security The API uses HTTPS as the underlying protocol to transfer data. The server hosts a certificate  to set up a secure connection using Transport Layer Security (TLS) version 1.2. The authenticity  of the server certificate is verifiable by the client using publicly available sources.  #### Authentication and authorization  The API should only be called by legitimate users with the correct access rights. The API uses  the Open Authorization 2.0 (OAuth) standard to achieve this. Every request to the API should  include a bearer access token in the JSON Web Token (JWT) format in the Authorization header.  The header should be formatted such as in the example below.  ```   {“Authorization”: “Bearer <JWT>”}  ``` The JWT must be acquired from one of the following identity providers:   * joule-technologies.eu.auth0.com    * inventum-app.eu.auth0.com    * joule-app.eu.auth0.com   For help regarding gaining an access token you can find the docs for Auth0  [here](https://auth0.com/docs/secure/tokens/access-tokens/get-access-tokens). The JWT must be intended for one of the following audiences:    * https://user-api.joule-cloud.com   If the authorization header does not match the requirements stated above the API will respond  with a 401-status code accompanied by an error code to specify the nature of the error.  ### Timeout The API specifies a maximum amount of time between a request and the response to avoid blocking  either side. The general timeout that has been set for each endpoint is 3000 milliseconds.  This timeout is used unless otherwise stated in the respective endpoint documentation.  If the server is unable to respond within this maximum time, the response contains a 504-status  code. The client may retry the request. The time out for a stream to be open is 1800 seconds.  If the stream is still open passed the experitation the server will close the stream. ### Rate limits  No rate limit is currently imposed. ### Diagnostics response  The diagnostics response provides the caller of the API with more information in case of a  failed request. This information can be used for debugging and recovery/retrying purposes.  The diagnostics response is always included under the “diagnostics” key if the response  has a body. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Device } from './Device';
import {
    DeviceFromJSON,
    DeviceFromJSONTyped,
    DeviceToJSON,
    DeviceToJSONTyped,
} from './Device';

/**
 * 
 * @export
 * @interface System
 */
export interface System {
    /**
     * 
     * @type {string}
     * @memberof System
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof System
     */
    addressLine1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof System
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof System
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof System
     */
    country?: string | null;
    /**
     * 
     * @type {Array<Device>}
     * @memberof System
     */
    devices?: Array<Device>;
    /**
     * 
     * @type {string}
     * @memberof System
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof System
     */
    highestErrorLevel?: string;
    /**
     * 
     * @type {string}
     * @memberof System
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof System
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof System
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof System
     */
    region?: string | null;
    /**
     * 
     * @type {string}
     * @memberof System
     */
    systemId?: string;
}

/**
 * Check if a given object implements the System interface.
 */
export function instanceOfSystem(value: object): value is System {
    return true;
}

export function SystemFromJSON(json: any): System {
    return SystemFromJSONTyped(json, false);
}

export function SystemFromJSONTyped(json: any, ignoreDiscriminator: boolean): System {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['account_id'] == null ? undefined : json['account_id'],
        'addressLine1': json['address_line1'] == null ? undefined : json['address_line1'],
        'addressLine2': json['address_line2'] == null ? undefined : json['address_line2'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'devices': json['devices'] == null ? undefined : ((json['devices'] as Array<any>).map(DeviceFromJSON)),
        'email': json['email'] == null ? undefined : json['email'],
        'highestErrorLevel': json['highest_error_level'] == null ? undefined : json['highest_error_level'],
        'name': json['name'] == null ? undefined : json['name'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'postalCode': json['postal_code'] == null ? undefined : json['postal_code'],
        'region': json['region'] == null ? undefined : json['region'],
        'systemId': json['system_id'] == null ? undefined : json['system_id'],
    };
}

export function SystemToJSON(json: any): System {
    return SystemToJSONTyped(json, false);
}

export function SystemToJSONTyped(value?: System | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['accountId'],
        'address_line1': value['addressLine1'],
        'address_line2': value['addressLine2'],
        'city': value['city'],
        'country': value['country'],
        'devices': value['devices'] == null ? undefined : ((value['devices'] as Array<any>).map(DeviceToJSON)),
        'email': value['email'],
        'highest_error_level': value['highestErrorLevel'],
        'name': value['name'],
        'phone': value['phone'],
        'postal_code': value['postalCode'],
        'region': value['region'],
        'system_id': value['systemId'],
    };
}

